import { useState } from "react";
import { Trash2, Plus } from "lucide-react";
import { api, FACT_SOURCES, FACT_TYPES } from "@/lib/api";

const sel = "bg-slate-900 border border-border rounded px-1.5 py-1 text-xs";

function AddFact({ client, roleId, onChange }) {
  const [text, setText] = useState("");
  const [type, setType] = useState("number");
  const [source, setSource] = useState("document");
  const add = async () => {
    if (!text.trim()) return;
    await api.post(`/clients/${client.id}/facts`, { role_id: roleId, text, type, source, verified: true });
    setText(""); onChange();
  };
  return (
    <div className="flex gap-2 mt-2">
      <input data-testid={`fact-add-input-${roleId}`} value={text} onChange={(e) => setText(e.target.value)} placeholder="Add a fact"
        className="flex-1 bg-slate-900 border border-border rounded-md px-2 py-1 text-sm outline-none focus:border-blue-500" />
      <select className={sel} value={type} onChange={(e) => setType(e.target.value)}>{FACT_TYPES.map((t) => <option key={t}>{t}</option>)}</select>
      <select className={sel} value={source} onChange={(e) => setSource(e.target.value)}>{FACT_SOURCES.map((t) => <option key={t}>{t}</option>)}</select>
      <button data-testid={`fact-add-button-${roleId}`} onClick={add} className="px-2 rounded bg-slate-800 hover:bg-slate-700"><Plus size={14} /></button>
    </div>
  );
}

export default function FactSheet({ client, facts, onChange }) {
  const roles = client.parsed_resume?.roles || [];
  const patch = async (f, upd) => { await api.put(`/facts/${f.id}`, upd); onChange(); };
  const del = async (f) => { await api.delete(`/facts/${f.id}`); onChange(); };
  return (
    <div className="space-y-4" data-testid="factsheet">
      <div className="text-sm text-muted-foreground">Only verified facts count toward the gate. Facts the AI pulled from documents start unverified, so tick them after checking.</div>
      {roles.map((r) => (
        <div key={r.id} className="card-surface">
          <div className="font-semibold mb-2">{r.title} <span className="text-muted-foreground font-normal">· {r.company}</span> <span className="font-mono text-xs text-blue-300 ml-1">{r.id}</span></div>
          <table className="w-full text-sm">
            <tbody>
              {facts.filter((f) => f.role_id === r.id).map((f) => (
                <tr key={f.id} className="border-t border-border" data-testid={`fact-row-${f.id}`}>
                  <td className="py-1.5 pr-2 w-8">
                    <input type="checkbox" data-testid={`fact-verify-${f.id}`} checked={!!f.verified} onChange={(e) => patch(f, { verified: e.target.checked })} className="accent-emerald-500" />
                  </td>
                  <td className="py-1.5 pr-2">
                    <input defaultValue={f.text} onBlur={(e) => e.target.value !== f.text && patch(f, { text: e.target.value })}
                      className="w-full bg-transparent outline-none focus:bg-slate-900 rounded px-1" />
                  </td>
                  <td className="w-24"><select className={sel} value={f.type} onChange={(e) => patch(f, { type: e.target.value })}>{FACT_TYPES.map((t) => <option key={t}>{t}</option>)}</select></td>
                  <td className="w-28"><select className={sel} value={f.source} onChange={(e) => patch(f, { source: e.target.value })}>{FACT_SOURCES.map((t) => <option key={t}>{t}</option>)}</select></td>
                  <td className="w-16 font-mono text-[10px] text-slate-500">{f.id.slice(0, 6)}</td>
                  <td className="w-6"><button onClick={() => del(f)} className="text-slate-500 hover:text-rose-400"><Trash2 size={13} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <AddFact client={client} roleId={r.id} onChange={onChange} />
        </div>
      ))}
    </div>
  );
}
